import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import { StyledTableCell, StyledTableRow, StyledTableHead } from './StyledTable.js'
import Paper from '@material-ui/core/Paper';
import CalendarHelper from '../classes/CalendarHelper.js';
import i18n from 'i18next';
import { withStyles } from '@material-ui/core/styles';

const useStyles = theme => ({
    tableContainer: {
        width: "100%",
        marginTop: theme.spacing(1),
        padding: theme.spacing(1)
    },
    table: {
        tableLayout: "fixed"
    },
    cellTitle: {
        fontWeight: 500,
        fontSize: "12px",
        borderLeftWidth: "0px",
        borderRightWidth: "0px",
        borderTopWidth: "0px",
        borderBottomWidth: "0px",
        userSelect: "none"
    },
    cellValue: {
        fontWeight: 500,
        fontSize: "12px",
        width: "100px",
        borderLeftWidth: "0px",
        borderRightWidth: "0px",
        borderTopWidth: "0px",
        borderBottomWidth: "0px",
        userSelect: "none"
    }
})

/**
 * UserAccountingSummary to be displayed with the accounting calendar
 */
class UserAccountingSummary extends Component {

    // Main render function
    render() {
        /**
         * Input data: 
         * this.props.year = current year
         * this.props.month = current month
         * this.props.data = { hoursTarget, hoursAccounted, hoursDiff, hoursOvertime, hoursAdjusted }
         */

        // Convert month index to human readable name
        const monthName = CalendarHelper.getMonthName( this.props.language, "short", this.props.month );

        // Create the table data array
        let tableData = [];
        if( null != this.props.data ) {
            tableData.push( { title: i18n.t("pages.main.accounting_user.summary.target_hours"), value: this.props.data.hoursTarget, align: "left", style: null } );
            tableData.push( { title: i18n.t("pages.main.accounting_user.summary.accounted_hours"), value: this.props.data.hoursAccounted, align: "left", style: null } );
            tableData.push( { title: i18n.t("pages.main.accounting_user.summary.adjusted_hours"), value: this.props.data.hoursAdjusted, align: "left", style: null } );
            tableData.push( { title: i18n.t("pages.main.accounting_user.summary.diff_hours"), value: this.props.data.hoursDiff, align: "left", style: null } );
            tableData.push( { title: i18n.t("pages.main.accounting_user.summary.overtime_hours"), value: this.props.data.hoursOvertime, align: "center", style: { borderStyle: "solid", borderLeftWidth: 1 } } );
        }

        return (
            <TableContainer key={"usersummary-container"} component={Paper} className={this.props.classes.tableContainer}>
                <Table key={"usersummary-table"} className={this.props.classes.table}>
                    <StyledTableHead key={"usersummary-header"}>
                        <StyledTableRow key={"usersummary-header-row-1"}>
                            <StyledTableCell key={"usersummary-header-row-1-col-1"} colSpan={tableData.length-1} align="center">{i18n.t("pages.main.accounting_user.summary.headline", { month: monthName, year: this.props.year })}</StyledTableCell>
                            <StyledTableCell key={"usersummary-header-row-1-col-2"} align="center" style={{ borderStyle: "solid", borderLeftWidth: 1 }} />
                        </StyledTableRow>
                    </StyledTableHead>
                    <TableBody key={"usersummary-body"}>
                        <StyledTableRow key={"usersummary-header-row-1"}>
                            {tableData.map((row, index) => {
                                return (
                                    <StyledTableCell key={"usersummary-body-row-1-col-"+index} colSpan={1} align={row.align} className={this.props.classes.cellTitle} style={row.style}>
                                        {row.title}
                                    </StyledTableCell>
                                )
                            })}
                        </StyledTableRow>
                        <StyledTableRow key={"usersummary-body-row-2"} >
                            {tableData.map((row, index) => {
                                return (
                                    <StyledTableCell key={"usersummary-body-row-2-col-"+index} align={row.align} className={this.props.classes.cellValue} style={row.style}>
                                        {row.value}
                                    </StyledTableCell>
                                )
                            })}
                        </StyledTableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
};

export default withStyles(useStyles)(UserAccountingSummary);